module.exports = __webpack_public_path__ + "static/media/7.d42c4507.png";